module.exports = __webpack_public_path__ + "static/media/02-1-galeria-01-dior-mobile@2x.e7becf6d.jpg";